import { TEXT } from './00_assets_types'

const ES =
{
  [ TEXT.UI_MENU_USERS         ]: 'Brugere'
, [ TEXT.UI_MENU_CLIENTS       ]: 'Kunder'
, [ TEXT.UI_MENU_WORKGROUPS    ]: 'Arbejdsgrupper'
, [ TEXT.UI_MENU_JOBS          ]: 'Opgaver'
, [ TEXT.UI_MENU_KEY_MASTERING  ]: 'Master nøglesystem'

, [ TEXT.UI_BUTTON_CREATE      ]: 'Skab'
, [ TEXT.UI_BUTTON_NEW         ]: 'Ny'
, [ TEXT.UI_BUTTON_OK          ]: 'Okay'
, [ TEXT.UI_BUTTON_CANCEL      ]: 'Afbestille'
, [ TEXT.UI_BUTTON_SAVE        ]: 'Gemme'
, [ TEXT.UI_BUTTON_LOGIN       ]: 'Log på'
, [ TEXT.UI_BUTTON_SEND        ]: 'Sende'


, [ TEXT.UI_EMAIL              ]: 'E-mail'
, [ TEXT.UI_ROLE               ]: 'Rolle'
, [ TEXT.UI_USERNAME           ]: 'Bruger'
, [ TEXT.UI_NAME               ]: 'Navn'
, [ TEXT.UI_DATE               ]: 'Dato'
, [ TEXT.UI_ADDR               ]: 'Adresse'
, [ TEXT.UI_DESC               ]: 'Beskrivelse'
, [ TEXT.UI_PRICE              ]: 'Pris'
, [ TEXT.UI_NO_DATA            ]: 'Ingen data'
, [ TEXT.UI_MACHINES           ]: 'Maskiner'
, [ TEXT.UI_USERS              ]: 'Brugere'
, [ TEXT.UI_DATE_FORMAT        ]: 'DD/MM/YYYY' // ES - date format Locale
, [ TEXT.UI_SING_OUT           ]: 'Log ud'
, [ TEXT.UI_MKS_TYPE           ]: 'Master nøglesystemtype'
, [ TEXT.UI_KEY_APP            ]: 'Nøgle brug'
, [ TEXT.UI_CLIENT             ]: 'Klient'
, [ TEXT.UI_FILE               ]: 'Kort'
, [ TEXT.UI_SELECT_FILE        ]: 'Vælg Fil'


, [ TEXT.UI_LOGIN_USERNAME     ]: 'Brugernavn'
, [ TEXT.UI_LOGIN_CLOUDNAME    ]: 'Sky'
, [ TEXT.UI_LOGIN_PASSWORD     ]: 'Adgangskode'



, [ TEXT.ARE_YOU_SURE          ]: 'Er du sikker?'


, [ TEXT.ERROR_NONE            ]: ''
, [ TEXT.ERROR_LOGIN_FORBIDDEN ]: 'Forkert bruger / sky eller adgangskode'
, [ TEXT.ERROR_LOGIN_UNAUTHORIZED ]: 'Forkert bruger / sky eller adgangskode'
, [ TEXT.ERROR_INTERNAL        ]: 'Intern serverfejl'
, [ TEXT.ERROR_FORBIDDEN       ]: 'Adgang nægtet'
, [ TEXT.ERROR_UNKNOWN         ]: 'Der opstod en fejl, og det er alt, hvad vi ved'

, [ TEXT.PAGE_NOT_FOUND        ]: 'Siden blev ikke fundet'

, [ TEXT.WORKGROUPS_NEW_TITLE  ]: 'Ny arbejdsgruppe'
, [ TEXT.WORKGROUPS_EDIT_TITLE ]: 'Rediger arbejdsgruppe'
, [ TEXT.WORKGROUPS_NAME       ]: 'Navn'


, [ TEXT.USERS_NEW_TITLE       ]: 'Ny bruger'
, [ TEXT.USERS_EDIT_TITLE      ]: 'Rediger bruger'


, [ TEXT.MACHINE_TYPE          ]: 'Maskintype'
, [ TEXT.MACHINE_NUM_JOBS      ]: '# Opgaver'
, [ TEXT.MACHINE_NAME          ]: 'Maskine'


, [ TEXT.CLIENT_NEW_TITLE      ]: 'Ny klient'
, [ TEXT.CLIENT_EDIT_TITLE     ]: 'Rediger klient'
, [ TEXT.CLIENT_ADDRESS        ]: 'Adresse'
, [ TEXT.CLIENT_CONTACT        ]: 'Kontakt'
, [ TEXT.CLIENT_CONTACT_EMAIL  ]: 'E-mail'
, [ TEXT.CLIENT_CONTACT_PHONE  ]: 'Telefon'
, [ TEXT.CLIENT_CONTACT_FAX    ]: 'Fax/Tlf'
, [ TEXT.CLIENT_SURNAMES       ]: 'Efternavn'
, [ TEXT.CLIENT_BIRTHDAY       ]: 'Fødselsdag'
, [ TEXT.CLIENT_NOTES          ]: 'Noter'
, [ TEXT.CLIENTS_FILTER_BY_NAME ]: 'Filternavn'
, [ TEXT.CLIENTS_FILTER_BY_ADDR ]: 'Filtrer adresse'
, [ TEXT.CLIENTS_FILTER_BY_CONTACT ]: 'Filtrer kontakt'
, [ TEXT.CLIENT_ADDR_STREET1   ]: 'Adresse'
, [ TEXT.CLIENT_ADDR_STREET2   ]: ''
, [ TEXT.CLIENT_ADDR_CITY      ]: 'By'
, [ TEXT.CLIENT_ADDR_PROVINCE  ]: 'Provins'
, [ TEXT.CLIENT_ADDR_ZIP_CODE  ]: 'Postnummer'
, [ TEXT.CLIENT_ADDR_COUNTRY   ]: 'Land'


, [ TEXT.MACHINES_NEW          ]: 'Ny maskine'
, [ TEXT.MACHINE_SERIAL_NO     ]: 'Serienummer'

, [ TEXT.JOB_EDIT_TITLE        ]: 'Rediger Opgaver'
, [ TEXT.JOB_NEW_TITLE         ]: 'Ny Opgaver'
, [ TEXT.JOB_KEY_TYPE          ]: 'Nøgletype'
, [ TEXT.JOB_NUM_KEYS          ]: 'Beløb'
, [ TEXT.JOB_MACHINE           ]: 'Maskine'
, [ TEXT.JOB_STATUS            ]: 'Status'
, [ TEXT.JOB_DATE              ]: 'Dato'
, [ TEXT.JOB_QUANTITY          ]: 'Nyt beløb'
, [ TEXT.JOB_FILTER_BY_STATUS  ]: 'Filtrerstatus'
, [ TEXT.JOB_FILTER_BY_CLIENT  ]: 'Filtrer klienter'
, [ TEXT.JOB_FILTER_BY_MACHINE_NAME ]: 'Filter efter maskine'
, [ TEXT.JOB_FILTER_BY_KEY_TYPE]: 'Filtrer efter nøgle'
, [ TEXT.JOB_FILTER_BY_DATE    ]: 'Filtrer efter dato'

, [ TEXT.KEY_MASTERING_LAUNCH   ]: 'Lancering'
, [ TEXT.KEY_MASTERING_LAUNCH_N ]: 'Lancering ({num})'
, [ TEXT.KEY_MASTERING_NEW_TITLE ]: 'Indlæs masternøglesystem'
, [ TEXT.KEY_MASTERING_WILL_CREATE_N_KEYS ]: 'Der oprettes {num} taster. Er du sikker?'
, [ TEXT.KEY_MASTERING_KEYS_CREATED       ]: '{num} job (r) er oprettet'
, [ TEXT.KEY_MASTERING_NAME               ]: 'Master nøglesystemnavn'

, [ TEXT.LOGIN_FORGOT_PASSWORD_QUESTION ]: 'Glemt kodeord?'
, [ TEXT.LOGIN_FORGOT_PASSWORD_TITLE ]: 'Sendte hvileinstruktioner til'
, [ TEXT.LOGIN_SLOGAN                   ]: 'Den første skybaserede nøgldupliceringsapp'
, [ TEXT.LOGIN_QUALITY_POINTS           ]: `
<br>
<br>
<p class="login-quality-call mb-4">
  <strong>THE FUTURE OF KEY DUPLICATION</strong>
</p>
<ul class="login-sell-points">
  <li>Registrer kopier af nøgler, som du har udført til dine kunder</li>
  <br>
  <li>Gem oplysninger uden risiko for at miste dem, og få adgang til dem, uanset hvor du befinder dig</li>
  <br>
  <li>Automatiske opdateringer</li>
</ul>
`

, [ TEXT.LEGAL_TOS_TEXT              ]: 'Juridisk meddelelse'
, [ TEXT.LEGAL_PRIVACY_TEXT          ]: 'Privatlivspolitik'
, [ TEXT.LEGAL_MODEL_TEXT            ]: 'Aftalemodel'
, [ TEXT.LEGAL_TOS_LINK              ]: '/legal/da/legal_notice_da.pdf'
, [ TEXT.LEGAL_PRIVACY_LINK          ]: '/legal/da/privacy_policy_da.pdf'
, [ TEXT.LEGAL_MODEL_LINK            ]: '/legal/da/model_da.docx'

, [ TEXT.KEY_MODEL                   ]: 'Nøgle'
, [ TEXT.KEY_SERIES                  ]: 'Serie'
, [ TEXT.KEY_CODE                    ]: 'Kode'
, [ TEXT.KEY_DATA_SHEET              ]: 'Kort'
, [ TEXT.KEY_BITING                  ]: 'Bider'
, [ TEXT.KEY_APPLICATION             ]: 'Ansøgning'

, [ TEXT.ENUM_JOB_STATE_PENDING      ]: 'VERSERENDE'
, [ TEXT.ENUM_JOB_STATE_CANCELLED    ]: 'ANNULLERET'
, [ TEXT.ENUM_JOB_STATE_COMPLETE     ]: 'KOMPLET'
, [ TEXT.ENUM_JOB_STATE_PROCESSING   ]: 'FORARBEJDNING'

, [ TEXT.ENUM_USER_ROLE_ADMIN        ]: 'ADMIN'
, [ TEXT.ENUM_USER_ROLE_MANAGER      ]: 'MANAGER'
, [ TEXT.ENUM_USER_ROLE_USER         ]: 'USER'

, [ TEXT.ENUM_KEY_APP_CAR            ]: 'BIL'
, [ TEXT.ENUM_KEY_APP_HOME           ]: 'HJEM'
, [ TEXT.ENUM_KEY_APP_SECURITY       ]: 'SIKKERHED'
, [ TEXT.ENUM_KEY_APP_LOCK           ]: 'HÆNGELÅS'
, [ TEXT.ENUM_KEY_APP_UNSPECIFIED    ]: 'USPECIFICERET'

, [ TEXT.FORM_HAS_ERRORS             ]: 'Udfyld obligatoriske felter med rødt'
}

export default ES ;
